import config from "@/config";

const DXP_IAM_ID_HEADER = "dxp-iam-id";

/**
 * Operations that resolve the old/new id pair in the first place, so they can
 * never carry the new id.
 */
const IDENTITY_BOOTSTRAP_OPERATIONS = new Set(["AccountsV2"]);

let currentIamAccountId: string | undefined;

const toIdentityId = (value: string | undefined) =>
  value !== undefined && value.length > 0 ? value : undefined;

const isIdentityBootstrapOperation = (operationName: string | undefined) =>
  operationName !== undefined &&
  IDENTITY_BOOTSTRAP_OPERATIONS.has(operationName);

export function setCurrentIamAccountId(iamAccountId: string | undefined): void {
  currentIamAccountId = toIdentityId(iamAccountId);
}

/** The `dxp-iam-id` header is rolled out per environment through config alone. */
export function isCdhIdIamIdMigrationEnabled(): boolean {
  return config.cdhIdIamIdMigrationEnabled === true;
}

/** Selected dealer's IAM id, falling back to the one the token was authorized with. */
function getIamAccountId(tokenIamAccountId?: string): string | undefined {
  return currentIamAccountId ?? toIdentityId(tokenIamAccountId);
}

export function getDxpIamAuthHeader(
  tokenIamAccountId?: string,
  operationName?: string
): Record<string, string> {
  if (
    !isCdhIdIamIdMigrationEnabled() ||
    isIdentityBootstrapOperation(operationName)
  ) {
    return {};
  }

  const iamAccountId = getIamAccountId(tokenIamAccountId);

  if (iamAccountId === undefined) {
    return {};
  }

  return { [DXP_IAM_ID_HEADER]: iamAccountId };
}
